(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Custom Dynamic Jump Menu (Table of Contents)
 * Requirements:
 * - A Content area with the class "js-jump-nav-sections"
 * - Each item in the ToCs should be it's own section
 * - A jump menu container with the class "js-jump-nav-menu"
 * - Jump menu should have link elements <a> equal to the number of sections in the content area (** This should be changed to be dynamic)
 */

class JumpMenu {
  constructor() {
    // Check if exists and initialize
    this.$jump_nav_container = $('.js-jump-nav-content');
    this.$jump_nav_menu = $('.js-jump-nav-menu');
    if (this.$jump_nav_container.length > 0 && this.$jump_nav_menu.length > 0) {
      this.init();
    }
  }
  init() {
    // Initialize component(s)
    this.$jump_sections_container = $('.js-jump-nav-sections');
    if (this.$jump_nav_menu.length > 0 && this.$jump_sections_container.length > 0) {
      // Wire up events for sections and nav menu
      this.initializeLinks();
      this.identifyPageSections();
      this.observeElements();
    } else {
      console.log('Jump menu components missing. Could not initialize.');
    }
    this.$menuTitle = $('.jump-navigation__header__title');
    this.mobileTitle = this.$menuTitle.data('mobile-title');
    this.desktopTitle = this.$menuTitle.text();
    this.initMobile();
    let posOffset = 200;
    let jump_section_top_pos = this.$jump_sections_container.offset().top - posOffset;
    let jump_section_bottom_pos = this.$jump_sections_container.offset().top + this.$jump_sections_container.height() - posOffset - posOffset;
    // console.log('outer height: ' + jump_section_bottom_pos );
    this.$window = $(window);
    this.$window.scroll(() => {
      // console.log( 'scroll top: ' + this.$window.scrollTop() );

      if (this.$window.scrollTop() >= jump_section_top_pos && this.$window.scrollTop() < jump_section_bottom_pos) {
        this.$jump_nav_menu.addClass('visible');
      } else if (this.$window.scrollTop() < jump_section_top_pos || this.$window.scrollTop() >= jump_section_bottom_pos) {
        this.$jump_nav_menu.removeClass('visible');
      }
    });
  }
  initializeLinks() {
    this.$jump_links = this.$jump_nav_menu.find('a');
    this.$jump_links.each((index, element) => {
      let linkAnchorText = element.text.replace(/\s+/g, '');
      linkAnchorText = linkAnchorText.replace(/&+/g, '');
      element.setAttribute('href', '#' + linkAnchorText);
    });
  }
  identifyPageSections() {
    this.$sections = $('.js-jump-nav-sections > ');
    this.$sections.each((index, element) => {
      let sectionId = this.$jump_links[index].getAttribute('href').replace('#', "");
      element.setAttribute('data-section', index);
      element.setAttribute('id', sectionId);
      element.classList.add('js-jump-section');
    });
  }
  observeElements() {
    this.sectionObserver = new IntersectionObserver((changes, observer) => {
      this.sectionIntersection(changes, observer);
    }, {
      rootMargin: "-80px 0px -80px 0px",
      threshold: 0
    });
    this.$sections.each((index, element) => {
      this.sectionObserver.observe(element.firstChild);
    });
  }
  sectionIntersection(changes, observer) {
    changes.forEach(change => {
      let isIntersecting = change.isIntersecting;
      let target = change.target.parentNode;
      if (isIntersecting) {
        let sectionId = target.getAttribute('id');
        let linkHref = "#" + sectionId;
        this.$jump_links.removeClass('active');
        this.$jump_nav_menu.find('a[href="' + linkHref + '"]').addClass('active');
      }
    });
  }
  initMobile() {
    this.mediaQuery = window.matchMedia('(max-width: 991px)');
    this.mediaQuery.addEventListener('change', e => {
      this.responsiveHandler(e);
    });
    if (this.mediaQuery.matches) {
      this.$jump_nav_menu.addClass('collapse');
      this.displayMobileTitle();
    } else {
      this.displayDesktopTitle();
    }
    this.$jump_nav_menu.on('click', () => {
      this.$jump_nav_menu.toggleClass('open');
    });
    this.mobileCloseBtn = $('.jump-navigation__exit-button');
    this.mobileCloseBtn.on('click', e => {
      this.$jump_nav_menu.toggleClass('open');
      e.stopPropagation();
    });
  }
  responsiveHandler(e) {
    if (this.mediaQuery.matches) {
      this.$jump_nav_menu.addClass('collapse');
      this.displayMobileTitle();
    } else {
      this.$jump_nav_menu.removeClass('collapse');
      this.$jump_nav_menu.removeClass('open');
      this.displayDesktopTitle();
    }
  }
  displayMobileTitle() {
    this.$menuTitle.text(this.mobileTitle);
  }
  displayDesktopTitle() {
    this.$menuTitle.text(this.desktopTitle);
  }
}
var _default = JumpMenu;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _jumpMenu = _interopRequireDefault(require("./modules/jump-menu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

window.$ = jQuery;

// import BackToTop from './modules/back-to-top';

// import SocialSharePopups from './modules/social-share-popups';

$(document).ready(function () {
  $('html').addClass('js-on-load');

  // const backToTop = new BackToTop();
  const jumpMenu = new _jumpMenu.default();
  // const socialSharePopups = new SocialSharePopups();

  // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/jump-menu":1}]},{},[2]);
